import { SailStatus } from '@/root/shared-types'

export const SAIL_STATUS: Record<string, SailStatus> = {
  PENDING: 'PENDING',
  OPEN: 'OPEN',
  CHECK_IN: 'CHECK-IN',
  CLOSED: 'CLOSED',
  TRAVELLED: 'TRAVELLED',
  CANCELLED: 'CANCELLED',
} as const

export const validStatuses: SailStatus[] = [SAIL_STATUS.OPEN, SAIL_STATUS.CLOSED, SAIL_STATUS.CANCELLED]
